<template src="./Footer.component.html"></template>
<style type="text/css" src="./Footer.component.css"></style>

<script>
export default {
  name: 'Footer',
  data () {
    return {}
  },
  methods: {
    downloadFile(item){
      if(item === 'Prospectus'){
        var url = 'https://res.cloudinary.com/dt0pdr6lb/image/upload/v1547202373/PROSPECTUS-ATEE.pdf' 
        window.open(url, '_blank');
      } else if(item === 'Présentation'){
        var url = 'https://res.cloudinary.com/dt0pdr6lb/image/upload/v1547199084/DOSSIER_DE_PRESENTATION_ATEE_2019.pdf' 
        window.open(url, '_blank');
      }
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/Footer/Footer.component.vue